import moment from "moment";
import { formatPrice } from "../../../common/formatPrice";
import { getValue } from "../../../common/getValue";
import { defaultRetur } from "./data";

export function GET_RETURS_REQUEST(state) {
  state;
  state.returs = {
    ...state.returs,
    isLoading: true,
  };
}

export function GET_RETURS_SUCCESS(state, payload) {
  let data = [];
  const { retur, meta } = payload.data.data;
  retur.map((item) => {
    let paymentTerm = "-";
    if (item.paymentTerm === "BT") {
      paymentTerm = "Bank Transfer";
    } else if (
      item.paymentTerm === "OD-GIRO" ||
      item.paymentTerm === "OD-CASH" ||
      item.paymentTerm === "OD"
    ) {
      paymentTerm = "COD";
    } else if (
      item.paymentTerm === "CR-GIRO" ||
      item.paymentTerm === "CR-CASH" ||
      item.paymentTerm === "CR"
    ) {
      paymentTerm = "TOP";
    }
    data.push({
      branchCodeData: getValue(item, "branchCode", "-"),
      returId: getValue(item, "orderId", "-"),
      status: getValue(item, "returStatus", "-"),
      oracleCustomerId: getValue(item, "oracleCustomerId", "-"),
      customerName: getValue(item, "customerName", "-"),
      customerId: getValue(item, "user.customerId", "-"),
      paymentStatus: getValue(item, "payment.status", "-"),
      paymentMethod: paymentTerm,
      totalValue: formatPrice(getValue(item, "total", 0)),
      created: moment(item.createdAt).format("DD-MM-YYYY hh:mm:ss") || "-",
      updated: moment(item.updatedAt).format("DD-MM-YYYY hh:mm:ss") || "-",
    });
    return item;
  });
  state;
  state.returs = {
    data: data,
    count: meta.total_data,
    status: payload.data.data.status,
    isLoading: false,
  };
}
export function GET_RETURS_ERROR(state, payload) {
  state;
  state.returs = {
    isLoading: false,
    error: true,
    errorMessage: payload,
  };
}

export function GET_RETUR_REQUEST(state) {
  state;
  state.retur = {
    ...state.retur,
    isLoading: true,
  };
}
export function GET_RETUR_SUCCESS(state, payload) {
  const generateData = defaultRetur(payload.data.data);
  const { retur, payment, shipTo, billTo, branchCodeData } = generateData;
  const totalPromoCart = retur.discount
    .filter((item) => item.discountType === "cart")
    .reduce((p, c) => p + c.discAmount, 0);
  const totalPromoPaymentMethod = retur.discount
    .filter((item) => item.discountType === "payment_method")
    .reduce((p, c) => p + c.discAmount, 0);
  let titlePromoCart = "-",
    titlePromoPaymentMethod = "-";
  retur.discount.map((item) => {
    if (item.discountType === "cart") {
      titlePromoCart = item.title;
    } else if (item.discountType === "payment_method") {
      titlePromoPaymentMethod = item.title;
    }
    return item;
  });
  const tempOrderDetail = [];
  retur.orderDetail.map((item) => {
    const discountAmount = item.discount.reduce((p, c) => p + c.discAmount, 0);
    const totalPromoLines = item.discount
      .filter((subItem) => subItem.discountType === "lines")
      .reduce((p, c) => p + c.discAmount, 0);
    const totalPromoStrata = item.discount
      .filter((subItem) => subItem.discountType === "strata")
      .reduce((p, c) => p + c.discAmount, 0);
    const totalPromoVoucher = item.discount
      .filter((subItem) => subItem.discountType === "voucher")
      .reduce((p, c) => p + c.discAmount, 0);
    tempOrderDetail.push({
      itemName: getValue(item, "itemData.itemName", "-"),
      uomCode: item.uomCode,
      ppn: item.ppn,
      qty: item.qty,
      itemPrice: `Rp. ${formatPrice(getValue(item, "price", 0))}`,
      total: `Rp. ${formatPrice(item.price * item.qty)}`,
      amtIncludeTax: `Rp. ${formatPrice(getValue(item, "amtIncludeTax", 0))}`,
      amtAfterDiscount: `Rp. ${formatPrice(
        getValue(item, "amtAfterDiscount", 0)
      )}`,
      totalPromoLines: `Rp. ${formatPrice(totalPromoLines)}`,
      totalPromoStrata: `Rp. ${formatPrice(totalPromoStrata)}`,
      totalPromoVoucher: `Rp. ${formatPrice(totalPromoVoucher)}`,
      discountAmount: `Rp. ${formatPrice(discountAmount)}`,
      taxAmount: `Rp. ${formatPrice(getValue(item, "taxAmount", 0))}`,
      reason: item.reason,
    });
  });
  let paymentCode = "-";
  if (payment.paymentCode === "BT") {
    paymentCode = "Bank Transfer";
  } else if (
    payment.paymentCode === "OD-GIRO" ||
    payment.paymentCode === "OD-CASH" ||
    payment.paymentCode === "OD"
  ) {
    paymentCode = "COD";
  } else if (
    payment.paymentCode === "CR-GIRO" ||
    payment.paymentCode === "CR-CASH" ||
    payment.paymentCode === "CR"
  ) {
    paymentCode = "TOP";
  }
  const data = {
    branchCodeData: branchCodeData.branch,
    returStatus: retur.returStatus,
    orderCreatedAt: moment(retur.orderDate).format("DD MMMM YYYY hh:mm:ss"),
    paymentCode: paymentCode,
    paymentValue: `Rp. ${formatPrice(payment.billAmount)}`,
    paymentAmount: `Rp. ${formatPrice(
      payment.bankAccountCustomer.paymentAmount
    )}`,
    paymentNote: payment.bankAccountCustomer.notes,
    orderDetail: [...tempOrderDetail],
    subTotal: `Rp. ${formatPrice(retur.subTotal)}`,
    totalPromoCart: `Rp. ${formatPrice(totalPromoCart)}`,
    totalPromoPaymentMethod: `Rp. ${formatPrice(totalPromoPaymentMethod)}`,
    titlePromoCart: titlePromoCart,
    titlePromoPaymentMethod: titlePromoPaymentMethod,
    subTotalAfterPromo: `Rp. ${formatPrice(
      retur.subTotal - totalPromoCart - totalPromoPaymentMethod
    )}`,
    taxRate: `Rp. ${formatPrice(retur.taxRate)}`,
    total: `Rp. ${formatPrice(retur.total)}`,
    oracleCustomerId: retur.oracleCustomerId,
    returId: retur.returId,
    paymentId: payment._id,
    ship_to: {
      country: shipTo.country,
      province: shipTo.province,
      city: shipTo.city,
      state: shipTo.state,
      address: shipTo.address,
      postal_code: shipTo.postalCode,
      phone_number: shipTo.primaryPhoneNumber,
      contact_person: shipTo.contactPerson,
      contact_phone_number: shipTo.contactPhoneNumber,
    },
    bill_to: {
      country: billTo.country,
      province: billTo.province,
      city: billTo.city,
      state: billTo.state,
      address: billTo.address,
      postal_code: billTo.postalCode,
      phone_number: billTo.primaryPhoneNumber,
      contact_person: billTo.contactPerson,
      contact_phone_number: billTo.contactPhoneNumber,
    },
    shipping: {
      status: payment.status,
      estimateArrival: payment.estimateArrival,
    },
    imageBuktiTransfer: payment.bankAccountCustomer.paymentSlipUrl,
    photos: retur.photos,
  };
  state;
  state.retur = {
    data: data,
    status: payload.status,
    isLoading: false,
  };
}
export function GET_RETUR_ERROR(state, payload) {
  state;
  state.retur = {
    isLoading: false,
    error: true,
    errorMessage: payload,
  };
}

export function EDIT_RETUR_REQUEST(state) {
  state;
  state.retur = {
    ...state.retur,
    isLoading: true,
  };
}
export function EDIT_RETUR_SUCCESS(state, payload) {
  state;
  state.retur = {
    ...state.retur,
    isLoading: false,
    error: false,
    errorMessage: "",
    data: {
      ...state.retur.data,
      returStatus: payload.data.data.returStatus,
    },
  };
}
export function EDIT_RETUR_ERROR(state, payload) {
  state;
  state.retur = {
    ...state.retur,
    isLoading: false,
    error: true,
    errorMessage: payload,
  };
}
